export default __webpack_public_path__ + "static/media/van.d72d7b8d.png";